import type { debt_registry } from '@axo/shared/data-access/types';
import type {
  DebtRegistryData,
  DebtRegistryPatchConsentData,
} from '@axo/shared/data-access/types/debt_registry';
import type { IAPI } from '../../lib/models/api';
import { send } from '../../lib/send';

export function updateDebts({ url: { service: baseURL }, token }: IAPI) {
  return async ({
    applicationID,
    SSN,
  }: {
    applicationID: string;
    SSN?: string;
  }): Promise<debt_registry.DebtRegistryDebts> => {
    return send({
      baseURL,
      token,
      path: `/debt-register/update`,
      method: 'POST',
      body: {
        loanApplicationID: applicationID,
        ssn: SSN,
      },
    });
  };
}

export function getDebts({ url: { service: baseURL }, token }: IAPI) {
  return async ({
    applicationID,
    SSN,
  }: {
    applicationID: string;
    SSN: string;
  }): Promise<debt_registry.DebtRegistryDebts> => {
    return send({
      baseURL,
      token,
      path: `/debt-register/${applicationID}/debts`,
      method: 'GET',
      headers: { ssn: SSN },
    });
  };
}

export function getConsent({ url: { service: baseURL }, token }: IAPI) {
  return async ({
    personID,
  }: {
    applicationID: string;
    personID: string;
  }): Promise<debt_registry.DebtRegistryConsent> => {
    return send({
      baseURL,
      token,
      path: `/debt-register/data/consent/${personID}`,
      method: 'GET',
    });
  };
}

/**
 * @description Patch to Debt Registry to check the consent...
 * GET endpoint only looks at the database atm... so if user revokes the consent on Gjeldsregisteret, it will still be marked as "consented" on database
 */
export function getPatchConsent({ url: { service: baseURL }, token }: IAPI) {
  return async ({
    applicationID,
  }: {
    applicationID: string;
    personID: string;
  }): Promise<DebtRegistryPatchConsentData> => {
    return send({
      baseURL,
      token,
      path: `/debt-register/${applicationID}/consent`,
      method: 'PATCH',
    });
  };
}

export function createConsent({ url: { service: baseURL }, token }: IAPI) {
  return async ({
    applicationID,
  }: {
    applicationID: string;
    personID: string;
  }): Promise<DebtRegistryData> => {
    return send({
      baseURL,
      token,
      path: `/debt-register/${applicationID}/consent`,
      method: 'POST',
    });
  };
}

export function getData({ url: { service: baseURL }, token }: IAPI) {
  return async ({
    applicationID,
  }: {
    applicationID: string;
  }): Promise<debt_registry.DebtRegistryData> => {
    return send({
      baseURL,
      token,
      path: `/debt-register/${applicationID}/data`,
      method: 'PATCH',
    });
  };
}
